import VueCookie from 'vue-cookies';

const cookieLocalStorage = {
    value: null,
    get(key) {
        const itemStr = localStorage.getItem(key);

        if (!itemStr) {
            return VueCookie.get(key);
        }

        const item = JSON.parse(itemStr);
        const now = new Date();
        if (now.getTime() > item.expiry) {
            localStorage.removeItem(key);
            VueCookie.remove(key);
            return null;
        }
        return item.value;
    },
    set(key, value, ttl) {
        const now = new Date();
        let ttlMillisec;
        if (typeof ttl === 'string') {
            const ttlNum = parseInt(ttl.slice(0, -1));
            const ttlPeriod = ttl.slice(-1).toUpperCase();
            switch (ttlPeriod) {
                case 'M':
                    ttlMillisec = ttlNum * 60 * 1000;
                    break;
                case 'H':
                    ttlMillisec = ttlNum * 60 * 60 * 1000;
                    break;
                case 'D': //
                    ttlMillisec = ttlNum * 24 * 60 * 60 * 1000;
                    break;
                default:
                    throw new Error('Invalid ttl period');
            }
        } else {
            ttlMillisec = ttl;
        }

        const item = {
            value: value,
            expiry: now.getTime() + ttlMillisec,
        };
        localStorage.setItem(key, JSON.stringify(item));
        VueCookie.set(key, value, ttl);
    },
    remove(key) {
        localStorage.removeItem(key);
        VueCookie.remove(key);
    },
};

export default cookieLocalStorage;
